import { render, staticRenderFns } from "./ucFoot.vue?vue&type=template&id=08ac377f"
import script from "./ucFoot.vue?vue&type=script&lang=js"
export * from "./ucFoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports